module.exports = __webpack_public_path__ + "6d15a1bb418e9f34d0606fd2d568b429.woff";